import api from '../../../api/clinique/_soin_hospitalisation'

export default {
    getListeChirurgies(){
        return new Promise((resolve,reject) => {
            api.getListeChirurgies().then(
                response => {
                    resolve(response)  
                }, error=> {
                    reject(error)
                }
            )
        })
    },
}